// extracted by mini-css-extract-plugin
module.exports = {"appContainer":"App_appContainer__T-fec","playContainer":"App_playContainer__aLDEw"};